(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ordan-cinematic-design"] && !Shopify.designMode) return;
  try {
    (() => {
    const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
    const desktop = window.matchMedia('(min-width: 1000px)');
    const root = document.documentElement;
    let stop = () => {};
    const initialise = () => {
      stop();
      if (!document.body.classList.contains('ordan-home')) return;
      const system = document.querySelector('[data-ordan-system]');
      const enabled = system ? system.dataset.enableMotion !== 'false' : true;
      const depth = system ? system.dataset.enableParallax !== 'false' : true;
      const moving = enabled && !preference.matches && !window.Shopify?.designMode;
      root.classList.toggle('ordan-motion-on', moving);
      const controller = new AbortController();
      const signal = controller.signal;
      const animations = new Set();
      let frame = 0;
      let revealObserver;
      let sceneObserver;
      const scenes = new Set();
      const allowed = (element) => moving && !element.closest('[data-ordan-motion="off"]');
      const revealTargets = [...document.querySelectorAll('[data-ordan-reveal], .shopify-section--featured-collection .product-card, .shopify-section--featured-collection .section-header, .shopify-section--blog-posts .section-header, .blog-post-card, .shopify-section--faq .section-stack__intro')];
      if (moving && 'IntersectionObserver' in window && Element.prototype.animate) {
        revealObserver = new IntersectionObserver((entries) => {
          entries.forEach(({ target, isIntersecting }) => {
            if (!isIntersecting) return;
            revealObserver.unobserve(target);
            if (target.contains(document.activeElement)) return;
            const animation = target.animate([
              { opacity: .35, transform: 'translate3d(0, 24px, 0)' },
              { opacity: 1, transform: 'translate3d(0, 0, 0)' }
            ], { duration: 750, easing: 'cubic-bezier(.22,1,.36,1)' });
            animations.add(animation);
            animation.finished.then(() => animations.delete(animation)).catch(() => animations.delete(animation));
          });
        }, { threshold: .06, rootMargin: '0px 0px -24px 0px' });
        revealTargets.forEach((element) => {
          if (allowed(element) && element.getBoundingClientRect().top > window.innerHeight - 24) revealObserver.observe(element);
        });
      }
      const heroes = [...document.querySelectorAll('[data-ordan-hero]')];
      const stories = [...document.querySelectorAll('[data-ordan-story]')].map((element) => ({
        element,
        steps: [...element.querySelectorAll('[data-ordan-step]')],
        bars: [...element.querySelectorAll('.ordan-field-notes__progress > span')],
        active: -1
      }));
      const clamp = (value) => Math.max(0, Math.min(1, value));
      const update = () => {
        frame = 0;
        if (document.hidden) return;
        heroes.forEach((hero) => {
          if (!scenes.has(hero)) return;
          const rect = hero.getBoundingClientRect();
          const value = allowed(hero) && depth && desktop.matches ? clamp(-rect.top / Math.max(1, rect.height)) : 0;
          hero.style.setProperty('--hero-scroll', value.toFixed(4));
        });
        stories.forEach((story) => {
          if (!scenes.has(story.element) || !story.steps.length) return;
          const rect = story.element.getBoundingClientRect();
          const value = allowed(story.element) && depth && desktop.matches ? clamp((window.innerHeight * .3 - rect.top) / Math.max(1, rect.height - window.innerHeight * .5)) : 0;
          story.element.style.setProperty('--story-progress', value.toFixed(4));
          let active = 0;
          let distance = Infinity;
          story.steps.forEach((step, index) => {
            const box = step.getBoundingClientRect();
            const current = Math.abs(box.top + Math.min(120, box.height / 2) - window.innerHeight * .54);
            if (current < distance) { distance = current; active = index; }
          });
          if (story.active === active) return;
          story.active = active;
          story.steps.forEach((step,index) => step.classList.toggle('is-active', index === active));
          story.bars.forEach((bar,index) => bar.classList.toggle('is-active', index <= active));
        });
      };
      const requestUpdate = () => { if (!frame && !document.hidden) frame = requestAnimationFrame(update); };
      const sceneElements = [...heroes, ...stories.map((story) => story.element)];
      if ('IntersectionObserver' in window) {
        sceneObserver = new IntersectionObserver((entries) => {
          entries.forEach(({target,isIntersecting}) => { if (isIntersecting) scenes.add(target); else scenes.delete(target); });
          requestUpdate();
        }, { rootMargin: '160px 0px' });
        sceneElements.forEach((element) => sceneObserver.observe(element));
      } else {
        sceneElements.forEach((element) => scenes.add(element));
      }
      window.addEventListener('scroll', requestUpdate, { passive: true, signal });
      window.addEventListener('resize', requestUpdate, { passive: true, signal });
      document.addEventListener('visibilitychange', requestUpdate, { signal });
      document.addEventListener('focusin', () => animations.forEach((animation) => animation.cancel()), { signal });
      requestUpdate();
      stop = () => {
        controller.abort();
        if (frame) cancelAnimationFrame(frame);
        revealObserver?.disconnect();
        sceneObserver?.disconnect();
        animations.forEach((animation) => animation.cancel());
        heroes.forEach((hero) => hero.style.removeProperty('--hero-scroll'));
        stories.forEach((story) => story.element.style.removeProperty('--story-progress'));
      };
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
    else initialise();
    preference.addEventListener('change', initialise);
    desktop.addEventListener('change', initialise);
    document.addEventListener('shopify:section:load', initialise);
    document.addEventListener('shopify:section:unload', () => requestAnimationFrame(initialise));
    window.addEventListener('pageshow', (event) => { if (event.persisted) initialise(); });
    window.addEventListener('pagehide', () => stop());
  })();
  } catch(e) { console.error(e); }
})();

})();
